export const GetPluralizationSubTitle = (count) => {
    return count === 0 ? 'zero' : count === 1 ? 'one' : 'other'
}
